var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaffle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11042",
    "data-name": "Group 11042",
    transform: "translate(23689 19915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(-23689 -19915)",
    fill: "#ffeaae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4333",
    "data-name": "Group 4333",
    transform: "translate(-23682.5 -19909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028",
    transform: "translate(0.75 6.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4018",
    "data-name": "Group 4018",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M101.853,229.978V238.6a1.125,1.125,0,0,0,1.125,1.125h12A1.125,1.125,0,0,0,116.1,238.6v-8.625Z",
    transform: "translate(-101.853 -229.978)",
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4019",
    "data-name": "Group 4019",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    width: 14.25,
    height: 0.75,
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4020",
    "data-name": "Group 4020",
    transform: "translate(12.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M379.152,229.978V238.6a1.125,1.125,0,0,1-1.125,1.125h1.125a1.125,1.125,0,0,0,1.125-1.125v-8.625Z",
    transform: "translate(-378.027 -229.978)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4021",
    "data-name": "Group 4021",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M115.353,238.978H103.728a.75.75,0,0,1-.75-.75v-8.25h-1.125V238.6a1.125,1.125,0,0,0,1.125,1.125h12A1.125,1.125,0,0,0,116.1,238.6v-.375A.75.75,0,0,1,115.353,238.978Z",
    transform: "translate(-101.853 -229.978)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4022",
    "data-name": "Group 4022",
    transform: "translate(12.375 8.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M378.027,421.348h1.125a1.125,1.125,0,0,0,1.125-1.125v-.375a.75.75,0,0,1-.75.75h-.444A1.122,1.122,0,0,1,378.027,421.348Z",
    transform: "translate(-378.027 -419.848)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4023",
    "data-name": "Group 4023",
    transform: "translate(13.5 0.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1471",
    "data-name": "Rectangle 1471",
    width: 1.125,
    height: 0.75,
    fill: "#1b4a8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4024",
    "data-name": "Group 4024",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1472",
    "data-name": "Rectangle 1472",
    width: 1.125,
    height: 0.75,
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4025",
    "data-name": "Group 4025",
    transform: "translate(0 4.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M106.723,339.169h-12a1.5,1.5,0,0,1-1.5-1.5v-3.75a.375.375,0,0,1,.75,0v3.75a.751.751,0,0,0,.75.75h12a.751.751,0,0,0,.75-.75v-2.25a.375.375,0,0,1,.75,0v2.25A1.5,1.5,0,0,1,106.723,339.169Z",
    transform: "translate(-93.223 -333.544)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4026",
    "data-name": "Group 4026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M107.848,226.973a.375.375,0,0,1-.375-.375v-4.5h-13.5v1.875a.375.375,0,0,1-.75,0v-2.25a.375.375,0,0,1,.375-.375h14.25a.375.375,0,0,1,.375.375V226.6A.375.375,0,0,1,107.848,226.973Z",
    transform: "translate(-93.223 -221.348)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027",
    transform: "translate(0 3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M93.6,300.15a.375.375,0,0,1-.375-.375V299.4a.375.375,0,1,1,.75,0v.375A.375.375,0,0,1,93.6,300.15Z",
    transform: "translate(-93.223 -299.025)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035",
    transform: "translate(0 3.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1473",
    "data-name": "Rectangle 1473",
    width: 15.75,
    height: 3,
    rx: 1.5,
    fill: "#5c88da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4030",
    "data-name": "Group 4030",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M99.592,160.935h-.75a.375.375,0,0,1,.375.375v1.5a.375.375,0,0,1-.375.375H84.967a.375.375,0,0,1-.375-.375v.375a.75.75,0,0,0,.75.75h14.25a.75.75,0,0,0,.75-.75v-1.5A.75.75,0,0,0,99.592,160.935Z",
    transform: "translate(-84.592 -160.935)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4031",
    "data-name": "Group 4031",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M99.592,160.935H85.342a.75.75,0,0,0-.75.75v1.5a.75.75,0,0,0,.75.75h.75a.375.375,0,0,1-.375-.375v-1.5a.375.375,0,0,1,.375-.375H99.967a.375.375,0,0,1,.375.375v-.375A.75.75,0,0,0,99.592,160.935Z",
    transform: "translate(-84.592 -160.935)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4032",
    "data-name": "Group 4032",
    transform: "translate(0.375 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M85.717,204.837v-.375h-.75a.375.375,0,0,1-.375-.375v.375a.75.75,0,0,0,.75.75h.75A.375.375,0,0,1,85.717,204.837Z",
    transform: "translate(-84.592 -204.087)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4033",
    "data-name": "Group 4033",
    transform: "translate(14.625 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M413.3,160.935h-.75a.375.375,0,0,1,.375.375v.375h.75a.375.375,0,0,1,.375.375v-.375A.75.75,0,0,0,413.3,160.935Z",
    transform: "translate(-412.549 -160.935)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    "data-name": "Group 4034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M91.337,156.054H77.087a1.126,1.126,0,0,1-1.125-1.125v-1.5a1.126,1.126,0,0,1,1.125-1.125h14.25a1.126,1.126,0,0,1,1.125,1.125v1.5A1.126,1.126,0,0,1,91.337,156.054Zm-14.25-3a.375.375,0,0,0-.375.375v1.5a.375.375,0,0,0,.375.375h14.25a.375.375,0,0,0,.375-.375v-1.5a.375.375,0,0,0-.375-.375Z",
    transform: "translate(-75.962 -152.304)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040",
    transform: "translate(6.375 6.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1474",
    "data-name": "Rectangle 1474",
    width: 3,
    height: 9.75,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1475",
    "data-name": "Rectangle 1475",
    width: 3,
    height: 0.75,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038",
    transform: "translate(0.375 9.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1476",
    "data-name": "Rectangle 1476",
    width: 3,
    height: 0.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M226.054,231.848h-3a.375.375,0,0,1-.375-.375v-9.75a.375.375,0,0,1,.375-.375h3a.375.375,0,0,1,.375.375v9.75A.375.375,0,0,1,226.054,231.848Zm-2.625-.75h2.25v-9h-2.25Z",
    transform: "translate(-222.679 -221.348)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045",
    transform: "translate(6.375 3.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4041",
    "data-name": "Group 4041",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1477",
    "data-name": "Rectangle 1477",
    width: 3,
    height: 3,
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042",
    transform: "translate(0.375 2.625)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1478",
    "data-name": "Rectangle 1478",
    width: 3,
    height: 0.75,
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1479",
    "data-name": "Rectangle 1479",
    width: 3,
    height: 0.75,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M226.054,156.054h-3a.375.375,0,0,1-.375-.375v-3a.375.375,0,0,1,.375-.375h3a.375.375,0,0,1,.375.375v3A.375.375,0,0,1,226.054,156.054Zm-2.625-.75h2.25v-2.25h-2.25Z",
    transform: "translate(-222.679 -152.304)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049",
    transform: "translate(9.375 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M300.353,78.381l4.818-1.14a.563.563,0,0,0,.3-.913l-.781-.911a2.245,2.245,0,0,0-1.709-.786,2.625,2.625,0,0,0-2.625,2.625Z",
    transform: "translate(-300.353 -74.631)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(0.513 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M308.515,76.327l-.781-.911a2.245,2.245,0,0,0-1.708-.786,2.626,2.626,0,0,0-2.487,1.782,2.615,2.615,0,0,1,1.737-.657,2.245,2.245,0,0,1,1.708.786l.707.824.527-.125a.563.563,0,0,0,.3-.913Z",
    transform: "translate(-303.539 -74.631)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M292.1,70.5a.375.375,0,0,1-.375-.375V69a3,3,0,0,1,3-3,2.623,2.623,0,0,1,1.993.917l.781.911a.938.938,0,0,1-.5,1.523l-4.818,1.14A.375.375,0,0,1,292.1,70.5Zm2.625-3.75a2.253,2.253,0,0,0-2.25,2.25v.651l4.356-1.031a.188.188,0,0,0,.1-.3l-.781-.911A1.874,1.874,0,0,0,294.723,66.75Z",
    transform: "translate(-291.723 -66)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4053",
    "data-name": "Group 4053",
    transform: "translate(1.125 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M115.734,78.381l-4.818-1.14a.563.563,0,0,1-.3-.913l.781-.911a2.245,2.245,0,0,1,1.709-.786,2.625,2.625,0,0,1,2.625,2.625Z",
    transform: "translate(-110.484 -74.631)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M113.859,75.756a2.615,2.615,0,0,1,1.737.657,2.626,2.626,0,0,0-2.487-1.782,2.245,2.245,0,0,0-1.709.786l-.781.911a.563.563,0,0,0,.3.913l.527.125.707-.824A2.245,2.245,0,0,1,113.859,75.756Z",
    transform: "translate(-110.484 -74.631)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4052",
    "data-name": "Group 4052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M107.478,70.5a.374.374,0,0,1-.086-.01l-4.818-1.14a.938.938,0,0,1-.5-1.523l.781-.911A2.623,2.623,0,0,1,104.853,66a3,3,0,0,1,3,3v1.125a.375.375,0,0,1-.375.375Zm-2.625-3.75a1.874,1.874,0,0,0-1.424.655l-.781.911a.188.188,0,0,0,.1.3l4.356,1.031V69A2.253,2.253,0,0,0,104.853,66.75Z",
    transform: "translate(-101.853 -66)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4057",
    "data-name": "Group 4057",
    transform: "translate(6.375 1.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M233.185,117.783h-.75a1.125,1.125,0,0,0-1.125,1.125v.75h3v-.75A1.125,1.125,0,0,0,233.185,117.783Z",
    transform: "translate(-231.31 -117.783)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4055",
    "data-name": "Group 4055",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M233.185,118.158h.75c.031,0,.06.007.091.009a1.118,1.118,0,0,0-.841-.384h-.75a1.125,1.125,0,0,0-1.125,1.125v.75h.75v-.375A1.125,1.125,0,0,1,233.185,118.158Z",
    transform: "translate(-231.31 -117.783)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4056",
    "data-name": "Group 4056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M226.054,111.777h-3a.375.375,0,0,1-.375-.375v-.75a1.5,1.5,0,0,1,1.5-1.5h.75a1.5,1.5,0,0,1,1.5,1.5v.75A.375.375,0,0,1,226.054,111.777Zm-2.625-.75h2.25v-.375a.751.751,0,0,0-.75-.75h-.75a.751.751,0,0,0-.75.75Z",
    transform: "translate(-222.679 -109.152)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaffle);
export default __webpack_public_path__ + "static/media/raffle.64eb8c0d121ac97b4442b1607e7cb939.svg";
export { ForwardRef as ReactComponent };